import { createContext, useContext, type ReactNode } from 'react';

export type ResolveProductImage = (productId: string) => Promise<string | undefined>;

const ProductImageContext = createContext<ResolveProductImage | undefined>(undefined);

export function ProductImageProvider({
  resolveProductImage,
  children,
}: {
  resolveProductImage?: ResolveProductImage;
  children: ReactNode;
}) {
  return (
    <ProductImageContext.Provider value={resolveProductImage}>{children}</ProductImageContext.Provider>
  );
}

export function useResolveProductImage(): ResolveProductImage | undefined {
  return useContext(ProductImageContext);
}
